// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"0066beab","287":"c3fab592","431":"7fc113c7","787":"ef22c676","958":"cdcabe80"}[chunkId] + ".chunk.js";
};